// native
import { NgModule } from "@angular/core";

// module
import { SharedModule } from "../shared/shared.module";

// component
import { AboutComponent } from "./about.component";

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    AboutComponent
  ]
})
export class AboutModule { }